import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import StudentLogin from './StudentLogin';
import Result from "./Result";

function App() {
  return (
    <BrowserRouter>

<Routes>

<Route path="/" element={<StudentLogin/>}/>
<Route path="/result" element={<Result/>} />

</Routes>

</BrowserRouter>

  );
}

export default App;
